import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';

const ActionPlan = ({ actions }) => {
  if (!actions || actions.length === 0) return null;

  return (
    <section
      data-testid="action-plan-section"
      style={{
        padding: '0 1.5rem 4rem',
        maxWidth: '900px',
        margin: '0 auto',
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.5 }}
        style={{ marginBottom: '2.5rem' }}
      >
        <div style={{
          fontFamily: 'var(--font-mono)', fontSize: '0.65rem',
          letterSpacing: '0.2em', textTransform: 'uppercase',
          color: 'var(--brand-purple)', marginBottom: '0.75rem',
        }}>
          Your Roadmap
        </div>
        <h2 style={{
          fontFamily: 'var(--font-heading)', fontSize: 'clamp(1.5rem, 3vw, 2rem)',
          fontWeight: 800, color: '#302B2C', letterSpacing: '-0.03em',
          lineHeight: 1.05, margin: 0,
        }}>
          What to do <span style={{ background: 'linear-gradient(135deg, #F67425, #BB0518)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>next</span>
        </h2>
      </motion.div>

      <div style={{ position: 'relative' }}>
        {/* Glowing timeline line */}
        <div style={{
          position: 'absolute',
          left: '19px',
          top: '24px',
          bottom: '24px',
          width: '2px',
          background: 'linear-gradient(to bottom, var(--brand-purple), rgba(246,116,37,0.1))',
          borderRadius: '1px',
        }} />

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
          {actions.slice(0, 6).map((action, i) => (
            <motion.div
              key={`action-${action.substring(0, 30)}`}
              data-testid={`action-step-${i}`}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.5, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              style={{
                display: 'flex', alignItems: 'flex-start', gap: '1.25rem',
                padding: '1.25rem 0',
                cursor: 'pointer',
                transition: 'transform 0.2s',
              }}
              onMouseEnter={e => e.currentTarget.style.transform = 'translateX(4px)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'translateX(0)'}
            >
              {/* Step number node */}
              <div style={{
                width: '40px', height: '40px', borderRadius: '50%',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: i === 0 ? 'linear-gradient(135deg, #F67425, #BB0518)' : '#fff',
                border: `1px solid ${i === 0 ? 'transparent' : 'rgba(48,43,44,0.15)'}`,
                flexShrink: 0, position: 'relative', zIndex: 1,
                boxShadow: i === 0 ? '0 0 20px rgba(246,116,37,0.3)' : 'none',
              }}>
                <span style={{
                  fontFamily: 'var(--font-heading)',
                  fontSize: '0.875rem', fontWeight: 700,
                  color: i === 0 ? '#fff' : 'var(--text-muted)',
                }}>
                  {i + 1}
                </span>
              </div>

              {/* Action text */}
              <div style={{
                flex: 1,
                paddingTop: '8px',
              }}>
                <p style={{
                  fontSize: '0.9375rem',
                  color: i === 0 ? '#302B2C' : 'var(--text-secondary)',
                  fontWeight: i === 0 ? 500 : 400,
                  lineHeight: 1.6,
                  margin: 0,
                }}>
                  {action}
                </p>
              </div>

              <ArrowUpRight
                size={16}
                color="var(--text-muted)"
                style={{ marginTop: '10px', flexShrink: 0, opacity: 0.5 }}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ActionPlan;
